import { render, staticRenderFns } from "./setBUs.vue?vue&type=template&id=49b118a0"
import script from "./setBUs.vue?vue&type=script&lang=js"
export * from "./setBUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports